import React from 'react';
import { browserHistory } from 'react-router'
import TouchLink from '../components/TouchLink';

const BookRouter = React.createClass({

    contextTypes: {
        userRef: React.PropTypes.object.isRequired,
        history: React.PropTypes.object.isRequired
    },

    componentWillMount() {
        if (this.context.userRef && this.context.userRef.val().isbn) {
            this.context.history.pushState(
                null
                ,`/book/${this.context.userRef.val().isbn}/chapters`
                , null);
        }
    },

    render() {
        return (
            <div>
                <br/><br/>
                Du har inte valt bok ännu, gå vidare till din
                <TouchLink to="/profile/book" className="text-wrap">
                    {" profil "}
                </TouchLink>
                och välj där den lärobok du använder.
            </div>
        );
    }
});

export default BookRouter;



/** WEBPACK FOOTER **
 ** ./src/screens/BookRouter.js
 **/